import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIService } from '../apiservices/apiservices';

type FrontendPromiseResult<T> = Promise<{Item: T | any, erro: string}>;

@Injectable()

export class EmpresaProvider {
  private header=APIService.getHeader();
  itemret;

  constructor(public http: HttpClient) {
  }

  public FiltrarShoppingsPorPerfisUsuario(shoppings: any[])
  {
    var usu = APIService.UsuarioLogado.Usuario;

    if(usu && usu.contratoLoginPerfils)
    {
      var perfis = usu.contratoLoginPerfils;

      var isTodsEmpresas = perfis.find(x => x.idEmpresa == "TODS" || x.idEmpresa == "TODOS_TODS") 
        ? true : false;

      if(isTodsEmpresas)
      {
        return shoppings;
      }

      var shoppingsFiltrados = shoppings.filter(x => perfis.find(y => y.idEmpresa == x.idEmpresa));

      return shoppingsFiltrados;
    }
    else
    {
      return shoppings;
    }
  }

  /**
   * Lista usuários
   * @param filtro filtro de nome ou cpf do usuário
   * @param forcarTods força devolver todas empresas
   * @returns 
   */
  get(filtro:any, forcarTods: boolean = false, extraParams = {}): FrontendPromiseResult<any[]> {
    var me=this;
    this.header=APIService.getHeader();

    return new Promise((resolve, reject) => {
  
      let url = APIService.API_URL + 'empresa?searchString=' + filtro;

      if (extraParams)
      {
        Object.keys(extraParams).forEach((key) => {
          url += '&' + key + '=' + extraParams[key];
        });
      }
      me.http.get(url,{headers:me.header})
        .subscribe((result: any) => {
          ////console.log(result);
          //resolve(result.json());
          var jsonData=result;

          if (jsonData.length!=0)
          {
            if (jsonData[0].status_ret!="NOK")
            {
                var datasuccess={
                  'Item':jsonData,
                  'erro':''
                }

                APIService.MALLS = jsonData;

                if(forcarTods)
                {
                  me.itemret=datasuccess;
                }
                else
                {
                  datasuccess.Item = me.FiltrarShoppingsPorPerfisUsuario(datasuccess.Item);
                  me.itemret=datasuccess;
                }
            }
            else{
              var errodatavazio={
                'Item':null,
                'erro':'Erro na consulta das empresas.'
              }
              me.itemret=errodatavazio;
            }
            
            //resolve(me.itemret);
          }
          else{
            var errodatavazio1={
              'Item':null,
              'erro':'Nenhum registro encontrado.'
            }
            me.itemret=errodatavazio1;
          }
          resolve(me.itemret);
        },
        (error) => {
          var msg="";
          if (error.status==401){
            msg=error.statusText;
          }
          else{
            msg=error.error;
          }
          let errojson =msg;

          var errochamada={
            'Item':null,
            'erro':errojson
          }
          me.itemret=errochamada;
          reject(me.itemret);
          
        });
    });
  }
}
